import styled from '@emotion/styled'
import { FC, ReactNode } from 'react'

interface Props {
  title?: string
  children: ReactNode
}

export const Section: FC<Props> = ({ title, children }) => (
  <Base>
    {title ? <Title>{title}</Title> : null}
    {children}
  </Base>
)

const Base = styled('div')`
  padding: 12px 0;

  & + & {
    border-top: 1px solid ${props => props.theme.gray5};
  }
`

const Title = styled('div')`
  padding: 12px 0 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: ${props => props.theme.gray9};
`
